package com.devi3east.bashbuddy.ktor.stripe.requests

import kotlinx.serialization.Serializable

@Serializable
data class CreateAccountLinkRequest(
    val accountId: String
)
